import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import {styled, useTheme} from '@mui/material/styles';
import * as React from 'react';
import APIWrapperContext from '../../../services/APIWrapperContext';
import {UserService} from '../../../services/openapi';
import UserContext from '../../../Contexts/UserContext/UserContext';

interface IUserDetailsProps {}

export default function UserDetails(props: IUserDetailsProps) {
  const {call_backend_api} = React.useContext(APIWrapperContext);
  const [userDetails, setUserDetails] = React.useState<any>({});
  const [userMetaDetails, setUserMetaDetails] = React.useState<any>({});
  const {name, additionalUserdata, user_roll} = React.useContext(UserContext);
  


  React.useEffect(() => {
    // call_backend_api(UserService.readUsersMeUserMeGet(),(t:any)=>setUserDetails(t),undefined,undefined,false)
    // call_backend_api(UserService.meAdditionalUserDataUserMeAdditionalUserDataGet(),(t:any)=>setUserMetaDetails(t),undefined,undefined,false)
  }, []);

  // Prüfen, ob user_roll existiert und additionalUserdata vorhanden ist
  const shouldRender = user_roll && additionalUserdata;

  // Nur rendern, wenn die notwendigen Bedingungen erfüllt sind
  if (!shouldRender) return null;

  const customTitle = (
    <Box sx={{textAlign: 'left'}}>
      <Typography
        variant='h4'
        sx={{
          fontWeight: 'bold',
        }}>
        {additionalUserdata.fullname ? `Hallo ${additionalUserdata.fullname}` : 'Willkommen'}
      </Typography>
    </Box>
  );

  return (
    <Card sx={{
      p: { xs: 1, sm: 2, md: 3 }  // Responsive padding: kleiner auf Mobile, größer auf Desktop
    }}>
      <CardHeader title={customTitle} />
      <CardContent>
        <Box
          sx={{
            display: 'flex',
          }}>
          <Box>{name && <Typography>Eigentümer: {name}</Typography>}</Box>
          <Box>
            {additionalUserdata.Ansprechpartner && (
              <Typography>Ihr Ansprechpartner: {additionalUserdata.Ansprechpartner}</Typography>
            )}
            {additionalUserdata.Mail_Ansprechpartner && (
              <Typography>
                Schreiben Sie uns eine Email: {additionalUserdata.Mail_Ansprechpartner}
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
